import React from 'react';
import classNames from 'classnames';

import { getTestId } from 'helpers/test-helpers';

interface TabProps {
  label: string;
  icon?: React.ReactNode;
  isActive?: boolean;
  isDisabled?: boolean;
  onClick?: () => void;
}

const Tab = ({ label, icon, isActive, isDisabled, onClick }: TabProps): React.JSX.Element => {
  const baseClasses = 'inline-block py-2 font-semibold';
  const activeClasses = 'text-navy-800 border-b-2 border-lime-400';
  const inactiveClasses = 'text-navy-500 hover:text-gray-600';
  const disabledClasses = 'text-gray-600 cursor-not-allowed';

  const className = classNames(baseClasses, {
    [disabledClasses]: isDisabled,
    [activeClasses]: isActive,
    [inactiveClasses]: !isActive,
  });

  const dataTestId = getTestId({
    prefix: 'navigation',
    label,
    suffix: 'tab',
  });

  return (
    <li className="me-2">
      <button
        type="button"
        onClick={onClick}
        className={className}
        disabled={isDisabled}
        data-testid={dataTestId}
      >
        {icon ? (
          <span className="inline-flex items-center gap-1.5">
            {icon}
            {label}
          </span>
        ) : (
          label
        )}
      </button>
    </li>
  );
};

export default Tab;
